import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { DeleteButton } from "../../component/common/Buttons"
import _ from 'lodash'

const { Column } = Table

type fetchParams = {
    position_name: string | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number
}

export default function Positions() {

    let fetchOtherParamsTmpl = {
        position_name: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>({
        position_name: undefined
    })

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0
    })

    const [data, setData] = useState<any>([])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleInputChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/manpower_center/position/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams

            }
        }).then((response: any) => {
            let p: any = { ...pagination }
            p.total = response.total

            setPagination(p)
            setData(response.records)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 人力中心 -> 组织架构 -> 职位管理 */}
        <BreadCrumb position={['人力中心', '职位管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="职位名称" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'position_name') }} value={fetchOtherParams.position_name} />

                <Button style={{ marginRight: 5, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 5, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                <Button style={{ marginRight: 5, marginBottom: 12 }} type="primary" ><Link to={"/positions_add"}>添加</Link></Button>
            </Space>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="职位名称" dataIndex="position_name" key="position_name" />
                <Column title="职位角色" dataIndex="role_name" key="role_name" />
                <Column title="职位编号" dataIndex="position_number" key="position_number" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button size="small" type="primary" ><Link to={"/positions_edit/" + record.id}>查看</Link></Button>
                            <DeleteButton url="/manpower_center/position/delete" record={record} cb={resetForm}>删除</DeleteButton>
                        </Space>
                    )}
                />
            </Table>
        </div>
    </div>)
}